import React from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import SnapshotSummary from "@/SnapshotSummary/index"
import ErrorBoundary from "@/ErrorBoundary"
import { TooltipProvider } from "~/components/ui/Tooltip"

const queryClient = new QueryClient()

interface SnapshotSummaryAppProps {
  year: number
  quarter: number
  context_scoped?: boolean
  quarters?: { label: string; path: string }[]
  context_name?: string
}

const SnapshotSummaryApp = ({
  year,
  quarter,
  context_scoped,
  quarters,
  context_name,
}: SnapshotSummaryAppProps) => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider delayDuration={0}>
      <ErrorBoundary>
        <SnapshotSummary
          year={year}
          quarter={quarter}
          contextScoped={!!context_scoped}
          quarters={quarters}
          contextName={context_name}
        />
      </ErrorBoundary>
    </TooltipProvider>
  </QueryClientProvider>
)

export default SnapshotSummaryApp
